import angular from 'angular';
import {
    NewDashboard,
    ScrollToTopComponent,
} from '@alquilatucancha/backoffice-integration';
import { registerBookingNavigationGuard } from './routing/booking-navigation-guard';

const moduleName = 'atc-backoffice-dashboard';

angular
    .module(moduleName, [])
    .directive('backofficeDashboard', [
        'Backoffice',
        'PlayersHistory',
        'Club',
        '$state',
        (Backoffice, PlayersHistory, Club, $state) => ({
            restrict: 'A',
            link: (_scope, el, attrs) => {
                const props = _scope.vm;

                Backoffice.renderComponent(el[0], NewDashboard, {
                    query_date: props.backoffice_date,
                    is_debug_mode: attrs?.isDebugMode === 'true',
                    old_dashboard_functions: {
                        registerBeforeNavigate: (guard) =>
                            registerBookingNavigationGuard(
                                _scope,
                                $state,
                                guard,
                            ),
                        getPlayerHistory: ({
                            player,
                            is_online_player,
                            tab_owes,
                        }) =>
                            PlayersHistory.open(
                                player,
                                is_online_player,
                                tab_owes,
                                true, // from_backoffice
                            ),
                        openPlayersModal: ({ onPhoneSelect }) => {
                            Club.openPlayersModal({
                                onPhoneSelect,
                                is_from_backoffice: true,
                            });
                        },
                    },
                });

                // Cuando se destruye el scope, desmontás el componente
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]); // <- Esto debe llamar a ReactDOM.unmountComponentAtNode
                });
            },
        }),
    ])
    .directive('scrollToTopFloatingButton', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ScrollToTopComponent, undefined, {
                    silent: true,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ]);

export default moduleName;
